/**
 * Geo-Gating-Konfiguration (Wettbewerbsschutz BE/NL).
 *
 * NICHT als Länder-Routing zu verstehen. Wettbewerber aus BE/NL sollen
 * den KVA und damit die Preise nicht sehen, aber echte deutsche
 * Grenzkunden (Aachen, Kleve, Bad Bentheim, ...) dürfen NICHT
 * fälschlich ausgesperrt werden.
 *
 * Daher Multi-Signal-Erkennung: IP + Browser-Sprache. Bei Unsicherheit
 * immer KVA zeigen (fail-open). `enabled: false` schaltet das Feature
 * komplett aus für schnelle Deaktivierung ohne Deploy-Bug-Hotfix.
 */
export const GEO_GATING_CONFIG = {
  enabled: true,

  // Länder, für die geprüft wird, ob die Info-Ansicht statt KVA gezeigt werden soll.
  // Nur in Kombination mit dem Sprach-Signal — die IP allein reicht NIE für ein Block.
  sensitiveCountries: ["BE", "NL"] as const,

  // Sprach-Präfixe die als "deutscher Kunde" gewertet werden.
  // Überstimmen das IP-Signal: BE/NL-IP + de-Sprache → KVA.
  germanLanguagePrefixes: ["de"] as const,

  // Sprach-Präfixe die das BE/NL-Signal bestätigen.
  // BE/NL-IP + nl/fr-Sprache → Info-Seite.
  nlBeLanguagePrefixes: ["nl", "fr"] as const,

  // Geo-Services
  primaryGeoService: "https://ipapi.co/json/",
  fallbackGeoService: "https://www.cloudflare.com/cdn-cgi/trace",
  timeoutMs: 2000,

  // Session-Cache: Entscheidung wird einmal pro Session gespeichert
  sessionStorageKey: "horsia_geo_decision",

  // Override-Parameter für manuelle Entsperrung. Wenn ?region=de in der URL
  // steht, wird KVA gezeigt + dauerhaft gecached. Für echte Kunden aus
  // Grenzregion, die wir intern auf die URL hinweisen können.
  overrideQueryParam: "region",
  overrideQueryValue: "de",

  // Debug-Param für interne Preview ohne IP-Spoof:
  // ?_geoPreview=info  →  zeigt Info-Seite (NL/BE-Erlebnis)
  // ?_geoPreview=kva   →  zeigt KVA (DE-Erlebnis)
  // Wird NICHT gecached, damit man frei zwischen Modi wechseln kann.
  previewQueryParam: "_geoPreview",
} as const;

export type GeoDecision = "kva" | "info";
